import React, { useEffect } from 'react';

const RedirectComponent = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uniqueid = params.get('uniqueid');
    const campaign = params.get('campaign');
    const vendor_id = params.get('vendor_id');
    const user = params.get('user');
    const phone_number = params.get('phone_number');
    const tipo_gestion = params.get('tipo_gestion');

    const newURL = `https://contact.hdcbpo.com/agente/predictivo?uniqueid=${uniqueid}&campaign=${campaign}&vendor_id=${vendor_id}&user=${user}&phone_number=${phone_number}&tipo_gestion=${tipo_gestion}`;
    window.location.href = newURL;
  }, []);

  return (
    <div>
      <h1>Redireccionando...</h1>
    </div>
  );
};

export default RedirectComponent;
